import { Button, Container, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'
import { useLoginLink } from 'services/loginLink'

import { appendSlackAltUTM } from '../appendSlackAlternativeUTM'

import css from './intro.module.css'

export function Intro() {
    const { t } = useTranslation('slackalternative')
    const { t: tcommon } = useTranslation('common')
    const loginLink = useLoginLink()

    return (
        <Container className={css.introContainer}>
            <Text tag="h1" size="major-3xl" className={css.introTitle}>
                {t('introTitle')}
            </Text>
            <Button href={appendSlackAltUTM(loginLink)} size="large">
                {tcommon('getStarted')}
            </Button>
        </Container>
    )
}
